import { render, staticRenderFns } from "./tabCustomerDevices.vue?vue&type=template&id=080e70fe&"
import script from "./tabCustomerDevices.vue?vue&type=script&lang=js&"
export * from "./tabCustomerDevices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports